import { render, staticRenderFns } from "./TitleConfig.vue?vue&type=template&id=09b52102&"
import script from "./TitleConfig.vue?vue&type=script&lang=js&"
export * from "./TitleConfig.vue?vue&type=script&lang=js&"
import style0 from "./TitleConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/TitleTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fcomponents%2Fadd-title-with-department-for-role%2FTitleConfig.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports